export default __webpack_public_path__ + "static/media/money_exchange.44ca50a9.png";